export default __webpack_public_path__ + "static/media/automation.f60c2878.png";